"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingAddressToJSON = exports.ShippingAddressFromJSONTyped = exports.ShippingAddressFromJSON = exports.instanceOfShippingAddress = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the ShippingAddress interface.
 */
function instanceOfShippingAddress(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfShippingAddress = instanceOfShippingAddress;
function ShippingAddressFromJSON(json) {
    return ShippingAddressFromJSONTyped(json, false);
}
exports.ShippingAddressFromJSON = ShippingAddressFromJSON;
function ShippingAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fullName': !(0, runtime_1.exists)(json, 'full_name') ? undefined : json['full_name'],
        'address1': !(0, runtime_1.exists)(json, 'address_1') ? undefined : json['address_1'],
        'address2': !(0, runtime_1.exists)(json, 'address_2') ? undefined : json['address_2'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : json['state'],
        'postalCode': !(0, runtime_1.exists)(json, 'postal_code') ? undefined : json['postal_code'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
    };
}
exports.ShippingAddressFromJSONTyped = ShippingAddressFromJSONTyped;
function ShippingAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'full_name': value.fullName,
        'address_1': value.address1,
        'address_2': value.address2,
        'city': value.city,
        'state': value.state,
        'postal_code': value.postalCode,
        'country': value.country,
    };
}
exports.ShippingAddressToJSON = ShippingAddressToJSON;
